import { PRODUCT_TYPES } from '@config/app.constants';

type Statuses<T extends PRODUCT_TYPES> = T extends typeof PRODUCT_TYPES.longlist
  ? typeof LONGLIST_PROGRESS_STEPS
  : T extends typeof PRODUCT_TYPES.shortlist
  ? typeof SHORTLIST_PROGRESS_STEPS
  : never;

const WORKFLOW_STATUS = {
  UNASSIGNED: 'UNASSIGNED',
  CONSULTANT_ASSIGNED: 'CONSULTANT_ASSIGNED',
  FIRST_SCREENING: 'FIRST_SCREENING',
  INITIAL_REVIEW: 'INITIAL_REVIEW',
  ACTIVE_SOURCING: 'ACTIVE_SOURCING',
  SECOND_SCREENING: 'SECOND_SCREENING',
  FINAL_PRESENTATION: 'FINAL_PRESENTATION',
  CANCELLED: 'CANCELLED',
} as const;

const SHORTLIST_PROGRESS_STEPS = {
  [WORKFLOW_STATUS.CANCELLED]: -1,
  [WORKFLOW_STATUS.UNASSIGNED]: 0,
  [WORKFLOW_STATUS.CONSULTANT_ASSIGNED]: 1,
  [WORKFLOW_STATUS.FIRST_SCREENING]: 2,
  [WORKFLOW_STATUS.INITIAL_REVIEW]: 3,
  [WORKFLOW_STATUS.SECOND_SCREENING]: 4,
  [WORKFLOW_STATUS.FINAL_PRESENTATION]: 5,
} as const;

const LONGLIST_PROGRESS_STEPS = {
  [WORKFLOW_STATUS.CANCELLED]: -1,
  [WORKFLOW_STATUS.UNASSIGNED]: 0,
  [WORKFLOW_STATUS.CONSULTANT_ASSIGNED]: 1,
  [WORKFLOW_STATUS.FIRST_SCREENING]: 2,
  [WORKFLOW_STATUS.ACTIVE_SOURCING]: 3,
  [WORKFLOW_STATUS.FINAL_PRESENTATION]: 5,
} as const;

const PROGRESS_STEPS = (productType: PRODUCT_TYPES) =>
  ({
    [PRODUCT_TYPES.shortlist]: SHORTLIST_PROGRESS_STEPS,
    [PRODUCT_TYPES.longlist]: LONGLIST_PROGRESS_STEPS,
  }[productType]);

const getProgressStep = <
  P extends PRODUCT_TYPES,
  S extends KeysOf<Statuses<P>>,
  R extends Statuses<P>[S],
>(
  productType: P,
  status: S,
): R => PROGRESS_STEPS?.(productType)?.[status as string] || 0;

export { getProgressStep, WORKFLOW_STATUS };
